module.exports = __webpack_public_path__ + "img/dumpattenuator_stopped.78102ca7.svg";